<template lang="pug">
    .page
      .container-fluid.p-5
          b-button(:to="{ name: 'Piece', params: { pieceId: rental.id, pieceTitle: this.kebabMe(rental.title) } }")
            font-awesome-icon.mr-2(icon="caret-left")
            span BACK TO PIECE
      section(v-if="rental")
        .container
          b-card
            b-container
              h1 RENTAL
              .row
                .col-4.col-md-2
                  .thumbnail(:style="{'background-image': `url(${rental.thumbnail_url})`}")
                .col-6.col-md-8
                  h4.m-0 {{ rental.title }}
                  p.m-0 {{ rental.artist }}
                  p.m-0 {{ `${formatRands(rental.price_rental)}/month` }}
              hr
              content-loader(:height="7", v-if="alert.loading")
              div(v-else="")
                .row.text-center
                  .col-12
                    p(v-if="!hasAddress || !account.user.is_verified") PLEASE COMPLETE YOUR PROFILE BEFORE CHECKING OUT
                    p(v-else="") YOUR MAY PROCEED TO CHECKOUT
                .row
                  .col-md-3.text-center
                    b-button.btn-outline(v-if="!hasAddress", :to="{name: 'AccountAddress', query: { sendmeback: 'true' }}") ADD ADDRESS
                    span(v-else="")
                      span.mr-2 ADDRESS
                      font-awesome-icon.text-success(icon="check")
                  .col-md-1.text-center.p-2
                    font-awesome-icon.d-none.d-md-inline-block(icon="chevron-right")
                    font-awesome-icon.d-inline-block.d-md-none(icon="chevron-down")
                  .col-md-3.text-center
                    b-button.btn-outline(v-if="!account.user.is_verified", :to="{name: 'AccountProfile', query: { sendmeback: 'true', launch: 'accountVerify' }}") VERIFY ID
                    span(v-else="")
                      span.mr-2 VERIFIED
                      font-awesome-icon.text-success(icon="check")
                  .col-md-1.text-center.p-2
                    font-awesome-icon.d-none.d-md-inline-block(icon="chevron-right")
                    font-awesome-icon.d-inline-block.d-md-none(icon="chevron-down")
                  .col-md-3.text-center
                    //span.mr-3 {{ `MONTHLY TOTAL ${formatRands(rental.price_rental)}` }}
                    b-button#btnCheckout.btn-outline(:to="{name: 'checkout', params: { type: 'rental' }}", :disabled="(!hasAddress || !isVerified)") CHECKOUT
      nothing(v-else="")
</template>

<script>
import { mapState } from 'vuex';
import { userService } from '@/services';
import standardMix from '@/mixins/standardMix';

export default {
  name: 'CheckoutPage',
  components: {
  },
  mixins: [standardMix],
  data() {
    return {
      hasAddress: false,
    };
  },
  computed: {
    ...mapState('cart', ['rental']),
  },
  methods: {
  },
  async created() {
    try {
      this.loading();
      // Check that customer has an address set
      const customer = await userService.getProfile(this.profileId);
      if (customer.address_id) {
        this.hasAddress = true;
      }
    } catch (error) {
      this.error('Error finding user');
    }
    this.clear();
  },
};
</script>

<style lang="scss" scoped>
.thumbnail {
  background-size: cover;
  background-repeat: no-repeat;
  background-position: center;
  width: 100px;
  height: 100px;
}
</style>



// WEBPACK FOOTER //
// src/components/views/Rent.vue